<style lang="scss">
@media screen and (min-width: 55rem) {
  .news-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 6rem;

    .news {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: row-reverse;
      justify-content: flex-start;
      height: auto;
      .news-img {
        width: 60%;
        .news-img-content {
          width: 100%;
          height: 0;
          padding: 0;
          // border-radius: 1rem;
          padding-bottom: 75%;
          background-size: cover;
            background-image: url("https://intime-web2021.oss-cn-shanghai.aliyuncs.com/1641462085441-e9c8a7db-6a61-482b-9b1f-bb82bcfb52dd.png");

          background-repeat: no-repeat;
          background-position: 50%;
        }
        min-height: 20rem;
      }
      .news-text {
        width: 40%;
        min-height: 10rem;
        margin-top: 3rem;
        .news-title {
          font-family: "PingFang SC", "Microsoft YaHei";
          font-size: 2.6rem;
          line-height: 1.4em;
          margin-top: 1rem;
          font-weight: 500;
        }
        .news-introduction {
          font-size: 1.5rem;
          font-family: "PingFang SC", "Microsoft YaHei";
          font-weight: 500;
          margin-top: 0.8rem;
        }
      }
    }
  }
}
@media screen and (max-width: 55rem) {
  .news-container {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 6rem;

    .news {
      width: 80%;
      max-width: 1080px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-end;
      height: auto;
      .news-img {
        width: 100%;
        .news-img-content {
          width: 100%;
          height: 0;
          padding: 0;
          // border-radius: 1rem;
          padding-bottom: 75%;
          background-size: cover;
            background-image: url("https://intime-web2021.oss-cn-shanghai.aliyuncs.com/1641462085441-e9c8a7db-6a61-482b-9b1f-bb82bcfb52dd.png");

          background-repeat: no-repeat;
          background-position: 50%;
        }
        min-height: 20rem;
      }
      .news-text {
        width: 100%;
        min-height: 10rem;
        margin-top: 3rem;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        .news-title {
          font-family: "PingFang SC", "Microsoft YaHei";
          font-size: 2.6rem;
          line-height: 1.4em;
          margin-top: 1rem;
          font-weight: 500;
        }
        .news-introduction {
          font-size: 1.5rem;
          font-family: "PingFang SC", "Microsoft YaHei";
          font-weight: 500;
          margin-top: 0.8rem;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>

<template>
  <div class="news-container">
    <div class="news">
      <div class="news-img"><div class="news-img-content"></div></div>
      <div class="news-text">
        <div class="news-title">银泰新闻</div>
        <div class="news-introduction">
          银泰新闻速递，所有的新鲜事儿都在这里
        </div>
        <a href="/news"><ButtonRed style="margin-top: 2rem"></ButtonRed></a>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonRed from "@/yintai/view/component/ButtonRed";

export default {
  name: "news",
  components: { ButtonRed },
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
